module.exports = __webpack_public_path__ + "img/black.d4e0566f.svg";